





















import { Component, Vue } from 'vue-property-decorator';
import { MUTATE_SHOW_WELCOME_MESSAGE } from '@/store/modules/interface';
import Tabs from '@/components/global/Tabs.vue';
import WelcomeMessage from '@/components/dashboard/WelcomeMessage.vue';

@Component({
    components: {
        Tabs,
        WelcomeMessage,
    },
})
export default class MyOrder extends Vue {
    public tabItems = [
        {
            label: 'Order List',
            name: 'order-list',
            route: 'order-list',
        },
    ];

    public mutateShowWelcomeMessage(state: boolean) {
        this.$store.commit(MUTATE_SHOW_WELCOME_MESSAGE, state);
    }

    // eslint-disable-next-line
    public beforeRouteEnter(to: any, from: any, next: any) {
        // if (to.name === 'default-analytics') {
        //     next({ name: 'analytics' });
        // }
        next((vm: any) => {
            if (from!.name === 'login') {
                vm.mutateShowWelcomeMessage(true);
            }
        });
    }

    get showWelcomeMessage() {
        return this.$store.getters.getShowWelcomeMessage;
    }
}

